import { createFileRoute } from '@tanstack/react-router';
import { NotificationsLayout } from '@/components/admin/notifications/NotificationsLayout.tsx';
import { HistoryTab } from '@/components/admin/notifications/history/HistoryTab.tsx';

export const Route = createFileRoute('/_app/admin/notifications/history/')({
  staticData: { orgScope: 'optional' },
  component: NotificationHistoryPage,
});

export function NotificationHistoryPage() {
  return (
    <NotificationsLayout active='history'>
      <HistoryTab />
    </NotificationsLayout>
  );
}
